import { Component, OnInit, OnChanges, Input, SimpleChanges} from '@angular/core';
// services
import { ReportFormatterService } from 'src/app/reports/services/report-formatter.service';

// models
import { ReportPayload } from 'src/app/reports/models/report-payload';
import { ReportCategory } from 'src/app/reports/models/report-category';
import { ReportTableColumn } from 'src/app/reports/models/report-table';
import { VehicleReportData } from 'src/app/reports/models/report-viewers';
import { ReportRecord } from 'src/app/reports/models/report-payload';
import { Columns } from 'src/app/reports/configs/report-columns.config';
import { ReportType } from 'src/app/reports/models/report-types';
import { ReportService } from 'src/app/reports/services/report.service';

@Component({
  selector: 'app-report-vehicles',
  templateUrl: './report-vehicles.component.html',
  styleUrls: ['./report-vehicles.component.scss', './../../report-viewer.component.scss']
})
export class ReportVehiclesComponent implements OnInit , OnChanges{
  @Input() report! : ReportPayload;
  @Input() category! : ReportCategory;
  @Input() columns! : ReportTableColumn[];

  vehicleData? : VehicleReportData;
  vehicleAllRecords : ReportRecord[] = []

  public withButtonGeneral = false;

  public buttonUpdateDriverList = false;

  constructor(
    private reportFormatterService: ReportFormatterService,
  ) { }


  ngOnInit(): void {
    // this.updateReport();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['report']) {
      this.updateReport(); // o lo que necesites ejecutar
    }
  }

  // EVENTS 
  updateReport(){
    this.formatReportTable();
  }


  // FUNCIONTS
  formatReportTable(){
    let currentType = this.report.reportDetails.reportType;
    if(currentType == ReportType.REPORTE_GENERAL){
      this.withButtonGeneral = true;
    } else {
      this.withButtonGeneral = false;
    }

    if(currentType == ReportType.REPORTE_CONDUCTORES_ENROLADOS){
      this.buttonUpdateDriverList = true;
    } else {
      this.buttonUpdateDriverList = false;
    }
    this.vehicleAllRecords = []
    this.vehicleData = this.report.dataViewer as VehicleReportData;
    if(this.vehicleData){
      if(this.report.filters.includeOnlyTable){
        this.columns.splice(1, 0, Columns.vehiculo);
        this.vehicleAllRecords = this.reportFormatterService.collectVehicleRecordsFromReport(this.vehicleData)
      }
    }
  }

  // SELECT VEHICLE
  public vehicleDropdownOptions : any = []
  public vehicleSelected = {
    name: '',
    dataSize: '',
    index: '',
  }
  private prepareVehicleDropdown(){
    this.vehicleDropdownOptions = [];
    for(let i = 0; i < this.report.data.length; i++){
      if( this.report.data[i][1].length == 0 ){
        //Si la tabla del vehiculo no tiene filas
        this.vehicleDropdownOptions.push({
          name: this.report.data[i][0][1],
          dataSize: ' (Sin registros)',
          index: this.report.data[i][0][0],
        });
      } else {
        this.vehicleDropdownOptions.push({
          name: this.report.data[i][0][1],
          dataSize: (this.report.data[i][1].length == 1? ' (1 registro)': (' (' + this.report.data[i][1].length +' registros)')),
          index: this.report.data[i][0][0],
        });
      }
    }
    if(this.vehicleDropdownOptions.length > 0){
      this.vehicleSelected = this.vehicleDropdownOptions[0];
    }
  }
}
